<template>
    <div>
        <LoadingOverlay :show="processingLogout">
            <Sidebar
                :openSidebar="sidebarTriggered"
                :staticSidebarState="staticSidebarOpen"
                @sidebarClosed="sidebarTriggered = false"
                @update:staticSidebarState="staticSidebarOpen = $event"
                @posClicked="handlePosClick"
            />
            <div
                :class="{ 'lg:pl-60': staticSidebarOpen, 'lg:pl-20': !staticSidebarOpen }"
                class="flex min-h-screen min-w-0 flex-col transition-all duration-150 ease-in-out"
            >
                <Topbar
                    @logging-out="processingLogout = true"
                    @logging-out-completed="processingLogout = false"
                />
                <main class="min-w-0 flex-grow pb-4">
                    <slot />
                </main>
                <Footer></Footer>
            </div>
        </LoadingOverlay>
    </div>
</template>

<script setup>
import Sidebar from '@/components/Layout/Main/Sidebar.vue';
import Topbar from '@/components/Layout/Sales/Topbar.vue';
import Footer from '@/components/Layout/Main/Footer.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import { ref, watch } from 'vue';
import { useAuthStore } from '@/stores/auth-store.js';
import { useRouter } from 'vue-router';

// Breadcrumbs are rendered by SalesLayout/Layout.vue with the page's own content.
const auth = useAuthStore();
const router = useRouter();

const processingLogout = ref(false);
const sidebarTriggered = ref(false);

// POS always uses the compact sidebar; elsewhere restore the user's saved preference.
const userPreferredSidebarState = ref(!!(auth?.user && auth.user.sidebar === 'open'));
const staticSidebarOpen = ref(
    router.currentRoute.value.name === 'pos' ? false : userPreferredSidebarState.value,
);

const handlePosClick = () => {
    userPreferredSidebarState.value = staticSidebarOpen.value;
};

watch(
    () => router.currentRoute.value.name,
    (newRoute, oldRoute) => {
        if (newRoute === 'pos') {
            staticSidebarOpen.value = false;
        } else if (oldRoute === 'pos') {
            staticSidebarOpen.value = userPreferredSidebarState.value;
        }
    },
);

watch(
    () => staticSidebarOpen.value,
    (newValue) => {
        if (router.currentRoute.value.name !== 'pos') {
            userPreferredSidebarState.value = newValue;
        }
    },
);
</script>

<style scoped></style>